import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-primary text-primary-foreground shadow-lg shadow-black/25 transition-[background-color,transform] hover:bg-primary-hover active:scale-[0.98]',
    secondary: 'bg-background/60 text-foreground border border-accent/30 transition-[background-color,transform] hover:bg-surface active:scale-[0.98]',
    outline: 'border-2 border-accent bg-transparent text-accent transition-colors hover:bg-background/60'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-5 py-5 text-sm sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 text-center rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-200" data-mp="om93kg44iub4">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-201" data-mp="12likji05lsg5" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-202" data-mp="xo8mxf2m2ah8">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-203" data-mp="1cf95we0zhmrm" />}
    </button>;
}